<template>
  <div class="elective-score-entry">
    <electiveScoreEntryTopBar
      @scoreEntryClick="scoreEntryClick"
      @search="search"
      :semesterOptions="semesterOptions"
      :semester="searchInfo.semester"
      :schoolYear="searchInfo.schoolYear"
      :gradeStudentList="gradeStudentList"
      :schoolCourseList="schoolCourseList"
    />
    <div class="elective-score-list" v-hasPermi="'sc:electivegrade:list'">
      <electiveScoreEntryTable
        :electiveGradeList="electiveGradeList"
        :schoolCourseList="schoolCourseList"
        :gradeStudentList="gradeStudentList"
        @editClick="editClick"
      />
    </div>
    <!-- 录入弹窗 -->
    <scoreEntryDialog
      :scoreEntryShow.sync="scoreEntryShow"
      :className="className"
      :classPlaceholder="classPlaceholder"
      :classProps="classProps"
      :classSelect="classSelect"
      :classSelectList="classSelectList"
      :gradeStudentList="gradeStudentList"
      :schoolCourseList="schoolCourseList"
      :searchInfo="searchInfo"
      @scoreEntryStudentSubmit="scoreEntryStudentSubmit"
    />
    <!-- 单个學生成績修改弹窗 -->
    <electiveScoreEdit
      v-if="scoreEditShow"
      :scoreEditShow.sync="scoreEditShow"
      :scoreEditData="scoreEditData"
      :schoolCourseList="schoolCourseList"
      :gradeStudentList="gradeStudentList"
      @editElectiveScore="editElectiveScore"
    />
  </div>
</template>

<script>
import electiveScoreEntryTopBar from "./components/elective-score-entry-top-bar/electiveScoreEntryTopBar.vue";
import electiveScoreEntryTable from "./components/elective-score-entry-table/electiveScoreEntryTable.vue";
import scoreEntryDialog from "./components/score-entry-dialog/scoreEntryDialog.vue";
import electiveScoreEdit from "./components/elective-score-edit/electiveScoreEdit.vue";
export default {
  components: {
    electiveScoreEntryTopBar,
    electiveScoreEntryTable,
    scoreEntryDialog,
    electiveScoreEdit,
  },
  data() {
    return {
      searchInfo: {
        semester: "",
        schoolYear: "",
      },
      electiveData: null,
      scoreEntryShow: false,
      scoreEditShow: false, // 单个修改弹窗
      scoreEditData: null, // 单个修改的数据
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "",
      classData: {
        classId: "",
        className: "",
      },
      gradeStudentList: [], // 学生列表
      electiveGradeList: [], // 选修成绩列表
      semesterOptions: [], // 学期选择列表
      schoolCourseList: [], // 学校科目列表
    };
  },
  provide() {
    return {
      refresh: this.getElectiveGradeList,
    };
  },
  created() {
    // 查询学校信息
    this.getSchoolDetails();
    // 获取学期类型选择列表数据
    this.getSemesterType();
    // 年级和班级选择列表
    this.selectSchoolAndGradeAndClassListPC();
    // 获取学校学生列表-单个学生成绩添加选择用
    this.selectStudentListPC();
    // 获取学校科目列表
    this.getCourseList();
  },
  methods: {
    // 修改选修评定
    editElectiveScore(data) {
      this.put(this.$url.editElectiveGrade, data).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.scoreEditShow = false;
        // 查询选修课成绩列表
        this.getElectiveGradeList();
      });
    },
    // 单个学生录入选修成绩
    scoreEntryStudentSubmit(e) {
      let data = {
        ...e,
        schoolYear: this.searchInfo.schoolYear,
        semester: this.searchInfo.semester,
      };
      this.post(this.$url.addElectiveGrade, data).then((res) => {
        // console.log("单个学生录入成绩：", res);
        if (res.code !== 200) return this.$message.error(res.msg || "录入失败");
        this.$message.success(res.msg || "录入成功");
        this.scoreEntryShow = false;
        // 查询选修课成绩列表
        this.getElectiveGradeList();
      });
    },
    // 获取学校科目列表
    getCourseList() {
      let data = {
        schoolId: this.user.schoolId,
        courseType: 1,
      };
      this.get(this.$url.getCourseList, data).then((res) => {
        // console.log("获取学校科目列表：", res);
        if (res.code !== 200) return;
        this.schoolCourseList = res.rows.filter(item => item.id !== -1);
      });
    },
    search(searchInfo) {
      this.searchInfo = searchInfo;
      this.getElectiveGradeList();
    },
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        this.searchInfo.semester = res.data.semester;
        this.searchInfo.schoolYear = res.data.schoolYear;
        // 查询选修课成绩列表
        this.getElectiveGradeList();
      });
    },
    // 获取学期类型选择列表数据
    getSemesterType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        this.semesterOptions = res.data;
      });
    },
    // 查询选修课成绩列表
    getElectiveGradeList() {
      let data = {
        studentId: this.searchInfo.studentId,
        courseId: this.searchInfo.courseId,
        schoolYear: this.searchInfo.schoolYear,
        semester: this.searchInfo.semester,
      };
      this.post(this.$url.getElectiveGradeList, data).then((res) => {
        // console.log("查询选修成绩列表:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.electiveGradeList = res.data;
      });
    },
    selectStudentListPC() {
      let data = {
        schoolId: this.user.schoolId,
      };
      this.get(this.$url.selectStudentListPC, data).then((res) => {
        // console.log("获取年级学生列表：", res);
        if (res.code !== 200) return;
        this.gradeStudentList = res.rows;
      });
    },
    // 单个修改
    editClick(item) {
      // console.log("item:", item);
      this.scoreEditData = item;
      this.scoreEditShow = true;
    },
    scoreEntryClick(e) {
      this.scoreEntryShow = e;
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          this.classSelectList = res.data;
          this.classSelectListLength = this.classSelectList.length;
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelect = this.classSelectList;
            // 默认选中时的classId/className
            this.classData.classId =
              this.classSelect[0].schoolClassList[0].classId;
            this.classData.className =
              this.classSelect[0].schoolClassList[0].className;

            // 默认选中第一个年级班级
            let firstGrade = {};
            let { gradeCode, gradeId, gradeName } = this.classSelect[0];
            firstGrade = { gradeCode, gradeId, gradeName };
            let firstClass = {};
            let { classCode, classId, className } =
              this.classSelect[0].schoolClassList[0];
            firstClass = { classCode, classId, className };
            this.className = [firstGrade, firstClass];
            this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
          }
          // console.log("this.this.classSelectList:", this.classSelectList);
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./electiveScoreEntry.scss";
</style>